import { useNavigate } from 'react-router-dom';
import { openExternalLink } from '../../../utils/openExternalLink';
import { useTranslation } from '../../../utils/useTranslation';
import { SmartDrawer } from '../../feedback/SmartDrawer';
import { Button } from '../../input/Button';
import { Box } from '../../layout/Box';
import { Flex } from '../../layout/Flex';
import { Typography } from '../../typography/Typography';
import { DISTRIBUTION_URL } from '../constants';

export const CpaAcceptedDialog = () => {
    const navigate = useNavigate();
    const t = useTranslation();

    const handleClose = () => {
        navigate(-1);
    };

    const handleLearnMore = () => {
        openExternalLink(DISTRIBUTION_URL);
    };

    const titleContent = (
        <Typography variant="title2" weight="bold">
            {t('Получить награду')}
        </Typography>
    );

    const mainContent = (
        <Flex direction="column" spacing={4}>
            <Flex spacing={1.5}>
                <Typography variant="body">
                    {t(
                        'Деньги будут начислены автоматически в течение следующего месяца на условиях, указанных в договоре, в частности при достижении 3 000 рублей.',
                    )}
                </Typography>
                <Typography variant="body">
                    {t(
                        'Информация не является офертой, частью договора или заверениями об обстоятельствах. Полные условия сотрудничества вы можете найти в договоре на распространение «Внешних товарных предложений для Яндекс Ритма».',
                    )}
                </Typography>
                <Typography variant="body">
                    {t(
                        'Если вы хотите ознакомиться со статистикой или расторгнуть договор, это можно сделать в кабинете Дистрибуции.',
                    )}
                </Typography>
            </Flex>

            <Box width="100%">
                <Button
                    variant="filled"
                    size="l"
                    width="100%"
                    color="secondary"
                    onClick={handleLearnMore}
                    style={{ letterSpacing: '0.7px' }}
                >
                    {t('Перейти в кабинет')}
                </Button>
            </Box>
        </Flex>
    );

    return (
        <SmartDrawer
            onClose={handleClose}
            titleContent={titleContent}
            mainContent={mainContent}
            forceCloseButton={true}
            hideTrigger={true}
        />
    );
};
